import moment from 'moment';
import {
  ORDER_PHASE_CONTACTING,
  ORDER_PHASE_PREPARING,
  ORDER_PHASE_DELIVERING,
  ORDER_PHASE_TAKEAWAY,
  ORDER_MISSED_LABEL,
  ORDER_CANCELED_LABEL,
  ORDER_COMPLETED_LABEL,
  ORDER_PHASE_CONTACTING_LABEL,
  ORDER_PHASE_PREPARING_LABEL,
  ORDER_PHASE_DELIVERING_LABEL,
  ORDER_SHOP_CANCELED_LABEL,
  ORDER_PHASE_TAKEAWAY_LABEL,
  ORDER_PHASE_WAITER_LABEL,
  ORDER_PHASE_WAITER,
  SHOP_CANCEL_PHASE_CONTACTING,
  CUSTOMER_CANCEL_PHASE_CONTACTING,
  ORDER_REFUND,
  ORDER_REFUND_LABEL,
  SHOP_CANCEL_AND_REFUND,
  ORDER_CANCELED,
  ORDER_PAST,
  ORDER_DELIVEROO,
  ORDER_JUSTEAT,
  ORDER_UBEREATS,
  ORDER_COMPLETED,
  ORDER_SUCCESS,
  ORDER_FUTURE,
  ORDER_IN_PROGRESS,
  ORDER_MOBILEAPP,
  ORDER_WEBAPP,
  ORDER_QRCODE,
  ORDER_TERMINAL,
  ORDER_PHASE_DELIVERING_TIME,
  ORDER_TYPE_DELIVERY
} from '../constants';
import _ from 'lodash'
import { showNotification } from '../components/Notification/Notification.view'
import store from './store';
export const getOrdersWithStatus = (orders, statusToGet, type = null) => {
  const ordersWithStatus = [];
  if (orders) {
    Object.keys(orders).forEach(orderId => {
      const order = orders[orderId];
      const { status, date } = order;
      const currentDate = moment().isSameOrAfter(moment(date).subtract(6, 'hours'), 'day');
      if (status === statusToGet) {
        if (type) {
          if (
            (type === ORDER_FUTURE && !currentDate) ||
            (type === ORDER_IN_PROGRESS && currentDate)
          ) {
            ordersWithStatus.push(order);
          }
        } else {
          ordersWithStatus.push(order);
        }
      }
    });
  }
  return ordersWithStatus;
};
export const setOpactity = (color, opacity) => {
  return `rgba(${color},${opacity})`;
};

export const getOrderStatusLabel = (type, cancelReason, status) => {
  switch (type) {
    case ORDER_PHASE_CONTACTING:
      return ORDER_PHASE_CONTACTING_LABEL;
    case ORDER_PHASE_PREPARING:
      return ORDER_PHASE_PREPARING_LABEL;
    case ORDER_PHASE_DELIVERING:
      return ORDER_PHASE_DELIVERING_LABEL;
    case ORDER_PHASE_TAKEAWAY:
      return ORDER_PHASE_TAKEAWAY_LABEL;
    case ORDER_PHASE_WAITER:
      return ORDER_PHASE_WAITER_LABEL;
    case ORDER_PAST:
      if (status === ORDER_REFUND) {
        return ORDER_REFUND_LABEL;
      }
      return ORDER_COMPLETED_LABEL;
    case ORDER_COMPLETED:
      return ORDER_COMPLETED_LABEL;
    case ORDER_SUCCESS:
      return ORDER_COMPLETED_LABEL;
    case ORDER_REFUND:
      return ORDER_REFUND_LABEL;
    case ORDER_CANCELED:
      if (status === ORDER_REFUND) {
        return ORDER_REFUND_LABEL;
      }
      switch (cancelReason) {
        case CUSTOMER_CANCEL_PHASE_CONTACTING:
          return ORDER_MISSED_LABEL;
        case SHOP_CANCEL_PHASE_CONTACTING:
          return ORDER_SHOP_CANCELED_LABEL;
        case SHOP_CANCEL_AND_REFUND:
          return ORDER_REFUND_LABEL;
        default:
          return ORDER_CANCELED_LABEL;
      }
    default:
      return '';
  }
};

export const isExternalApp = canal => {
  return canal === ORDER_DELIVEROO || canal === ORDER_JUSTEAT || canal === ORDER_UBEREATS;
};

export const isCompletedOrder = statusLabel => {
  if (
    statusLabel === ORDER_CANCELED_LABEL ||
    statusLabel === ORDER_COMPLETED_LABEL ||
    statusLabel === ORDER_MISSED_LABEL ||
    statusLabel === ORDER_REFUND_LABEL ||
    statusLabel === ORDER_SHOP_CANCELED_LABEL
  )
    return true;
  return false;
};

export const getCanalName = canal => {
  let canalName = '';
  switch (canal) {
    case ORDER_UBEREATS:
      canalName = 'Uber Eats';
      break;
    case ORDER_DELIVEROO:
      canalName = 'Deliveroo';
      break;
    case ORDER_JUSTEAT:
      canalName = 'Just Eat';
      break;
    case ORDER_QRCODE:
      canalName = 'QR code';
      break;
    case ORDER_TERMINAL:
      canalName = 'Borne';
      break;
    case ORDER_WEBAPP:
      canalName = 'Application';
      break;
    case ORDER_MOBILEAPP:
      canalName = 'Application';
      break;
    default:
      break;
  }
  return canalName;
};

export const getEstimationTime = order => {
  const { status, isSchedule } = order;
  const { date: dateOrder, dateSent = moment(), datePreparationStarted = moment() } = order;
  let date = moment(dateOrder);
  let datePreparationEnded = moment(dateOrder);

  switch (status) {
    case ORDER_PHASE_CONTACTING: {
      const { orderType } = order;
      if (!isSchedule) {
        date = moment(dateSent);
        datePreparationEnded = moment(dateSent).add(ORDER_PHASE_DELIVERING_TIME, 'm');
      } else if (orderType === ORDER_TYPE_DELIVERY) {
        datePreparationEnded = datePreparationEnded.subtract(ORDER_PHASE_DELIVERING_TIME, 'm');
      }
      return { datePreparationEnded, date };
    }
    default: {
      const { preparationTime, isSchedule, orderType } = order;
      if (isSchedule) {
        date = date.add(preparationTime, 'm');
        datePreparationEnded = datePreparationEnded.add(preparationTime, 'm');
        if (orderType === ORDER_TYPE_DELIVERY) {
          datePreparationEnded = datePreparationEnded.subtract(ORDER_PHASE_DELIVERING_TIME, 'm');
        }
      }

      const dateAsap = moment(datePreparationStarted).add(preparationTime, 'm');

      if (dateAsap.isAfter(datePreparationEnded)) {
        datePreparationEnded = dateAsap.clone();
      }
      if (orderType === ORDER_TYPE_DELIVERY) {
        dateAsap.add(ORDER_PHASE_DELIVERING_TIME, 'm');
      }
      if (dateAsap.isAfter(date)) {
        date = dateAsap.clone();
      }
      return { datePreparationEnded, date };
    }
  }
};

export const getSavedCanals = (webapp, mobileApp) => {
  const canals = [];
  if (mobileApp.enabled) {
    canals.push(ORDER_MOBILEAPP);
  }
  if (webapp.enabled) {
    canals.push(ORDER_WEBAPP);
  }

  return canals;
};
export const NoDriverToast = (oldOrder, order) => {
  const { generalConfig={} }= store.getState().firebaseRealTime;
  if (!_.isEqual(oldOrder?.delivery?.searchDriver, order?.delivery?.searchDriver) && !order?.delivery?.searchDriver && generalConfig?.delivery?.fleet?.showOrderInPreparation) {
    const alertMessage=`Nous n’avons pas trouvé de livreur disponible pour la commande <strong> ${order?.orderNumber} <strong>`
    showNotification(
      'light',
      'ltr',
      'warning',
      'Aucun livreur disponible',
      alertMessage,
      '',
      'true',
      'true'
    );
  }
}
